/**
 * Panels API Endpoints
 *
 * Panels are scoped per-instrument and identified by numeric `id`.
 * Panel mappings (by `mappingKey`) and panel tests (by `testId`) are sub-resources.
 */

export const PANELS_ENDPOINTS = {
  /** GET — list panels for an instrument, POST — create. */
  PANELS: (instrumentId: number) => `/instruments/${instrumentId}/panels`,

  /** GET — single panel by id. */
  PANEL_BY_ID: (instrumentId: number, panelId: number) => `/instruments/${instrumentId}/panels/${panelId}`,

  /** PUT — update panel by id. */
  UPDATE_PANEL: (instrumentId: number, panelId: number) => `/instruments/${instrumentId}/panels/${panelId}`,

  /** DELETE — remove panel. Fails if mappings or test memberships exist. */
  DELETE_PANEL: (instrumentId: number, panelId: number) => `/instruments/${instrumentId}/panels/${panelId}`,
} as const;
